export default __webpack_public_path__ + "static/media/pattern-camo.b8798dd5.png";